<template>
  <div class="firefighting-device-monitor">
    <router-view />

    <div v-if="!isSplitScreenMode" class="sensors-info" :class="{ hidden: isHidden }">
      <div class="btn" @click.stop="toggleHiddenHandle" v-if="!isHidden">
        <i class="el-icon el-icon-arrow-left" />
      </div>

      <el-descriptions class="margin-top" :column="3" size="medium">
        <el-descriptions-item v-for="item in options" :key="item.prop" :label="item.label">
          {{ weatherDeviceDetails[item.prop] }}{{ item.unit }}
        </el-descriptions-item>
      </el-descriptions>

      <div class="sensors-info_chart">
        <v-chart ref="mychart" :options="chartOpt" :autoresize="true"></v-chart>
      </div>

      <div>
        <el-button type="primary" size="medium" @click.stop="handleSendMsg">发送消息</el-button>
      </div>

      <div class="btn right" v-if="isHidden" @click="toggleHiddenHandle">
        <i class="el-icon el-icon-arrow-right" />
      </div>
    </div>
  </div>
</template>

<script lang="jsx">
import { mapState } from 'vuex';

import { isEmpty } from '@/utils/is';
import { openDevicePointMap } from '@/components/bmapGL/dialog';
import { setDeviceCoordinate } from '@/layout/commonActions/setDeviceCoordinate';
import MForm from '@/components/form/v2.vue';
import { useDialog } from '@/components/dialog/index.js';
import { sendIndMsg } from '@/api/deviceSetting';

export default {
  inject: ['weatherDeviceDetails', 'splitScreenMode'],

  data() {
    return {
      options: [
        {
          label: '温度',
          icon: 'iconfont icon-temperature2',
          prop: 'temp',
          unit: '℃'
        },
        {
          label: '气压',
          icon: 'iconfont icon-a-pressure',
          prop: 'atm',
          unit: 'kpa'
        },
        {
          label: '风向',
          icon: 'iconfont icon-a-wind-power',
          prop: 'windDirectionValue',
          unit: ''
        },
        {
          label: '湿度',
          icon: 'iconfont icon-humidity2',
          prop: 'humidity',
          unit: '%RH'
        },
        {
          label: '辐射',
          icon: 'iconfont icon-a-nuclid2',
          prop: 'radiation',
          unit: 'W/m³'
        },
        {
          label: '风速',
          icon: 'iconfont icon-wind-speed',
          prop: 'windSpeed',
          unit: 'm/s'
        }
      ],
      model: {
        temp: 10,
        pressure: 1013,
        windForce: 3,
        humidity: 50,
        nuclide: 0.5,
        windSpeed: 2
      },
      chartOpt: {
        tooltip: {
          show: false
        },
        series: [
          {
            title: {
              show: false
            },
            startAngle: 89,
            endAngle: -270,
            max: 360,
            clockwise: true,
            splitNumber: 8,
            name: '业务指标',
            type: 'gauge',
            axisLine: {
              lineStyle: {
                color: [[1, '#aaa']],
                width: 10,
                opacity: 0
              }
            },
            splitLine: {
              length: 12
            },
            axisTick: {
              splitNumber: 6
            },
            axisLabel: {
              show: false,
              formatter: _v => {
                // if (v === 0 || v === 360) return '北';

                return '';
              }
            },
            pointer: {
              width: 3
            },
            detail: {
              fontSize: 12,
              offsetCenter: [0, '50%'],
              formatter: function (value) {
                const directions = ['北', '西北', '东', '东南', '南', '西南', '西', '西北'];
                const index = Math.floor((value + 22.5) / 45) % 8;

                return directions[index];
              }
            },
            data: [{ name: '', value: 90 }]
          }
        ]
      },
      sendLoading: false,
      form: {
        config: {},
        options: [
          {
            prop: 'sns',
            type: 'select',
            dataKey: 'deviceList',
            componentProps: {
              multiple: true,
              props: {
                label: 'name',
                value: 'sn'
              }
            }
          },
          {
            prop: 'msgCode',
            type: 'select',
            dataKey: 'commandOpts',
            componentProps: {}
          }
        ],
        model: {
          sns: [],
          msgCode: ''
        },
        dataSource: {
          deviceList: [],
          commandOpts: [{ label: '撤离', value: '1' }]
        }
      },
      isHidden: false
    };
  },
  provide() {
    return {
      locateTo: params => this.showDevicePosition(params),
      setDevicePosition: params => this.setDevicePosition(params)
    };
  },
  computed: {
    ...mapState('socket', {
      deviceSNMap: 'deviceSNMap',
      deviceIdMap: 'deviceIdMap',
      allDeviceList: 'devicesSourseMap'
    }),
    isSplitScreenMode() {
      return this.splitScreenMode();
    }
  },
  methods: {
    toggleHiddenHandle() {
      this.isHidden = !this.isHidden;
    },
    handleSendMsg() {
      useDialog({
        title: '发送指令',
        width: '400px',
        slots: {
          default: () => (
            <div>
              <MForm props={this.form} />
            </div>
          ),
          footer: () => (
            <div style="display: flex; justify-content: center;">
              <el-button
                type="primary"
                size="medium"
                loading={this.sendLoading}
                onclick={() => this.sendMsg(this.form.model)}
              >
                发送
              </el-button>
            </div>
          )
        },
        onBeforeDestroy: () => {
          Object.assign(this.form.model, {
            sns: [],
            msgCode: ''
          });
        }
      });
    },
    async sendMsg(params) {
      try {
        this.sendLoading = true;

        await sendIndMsg(params);

        this.$message.success('发送成功');
      } catch (error) {
        console.log(error);
        this.$message.warning('发送失败');
      } finally {
        this.sendLoading = false;
      }
    },

    showDevicePosition(deviceInfo) {
      let { latitude, longitude, gps } = deviceInfo;

      if (!isEmpty(gps)) {
        [longitude, latitude] = gps;
      }

      openDevicePointMap({ coords: { longitude, latitude } });
    },
    setDevicePosition(deviceInfo) {
      setDeviceCoordinate(deviceInfo);
    }
  },
  watch: {
    weatherDeviceDetails: {
      handler(n) {
        if (isEmpty(n)) return;

        this.chartOpt.series[0].data[0].value = n.windDirection;
      },
      deep: true
    }
  },
  mounted() {
    this.allDeviceList.forEach(item => {
      if (item.deviceType == 'GW1034M') item.name = 'α、β表面沾污仪 ';
    });

    this.form.dataSource.deviceList.splice(0, Infinity, ...this.allDeviceList);

    this.$router.push({
      name: 'firefightingMonitorBMap'
    });
  }
};
</script>

<style lang="scss">
.firefighting-device-monitor {
  position: relative;
  height: 100%;

  pointer-events: none;

  --mtable-border-color: #1c3755;
  --mtable-bg-color: #112132;
  --mtable-color: #fff;
  --mtable-thead-color: #fff;
  --mtable-wrap-border: unset;
  --mtable-thead-fs: 18px;
  --mtable-tbody-fs: 16px;

  --descriptions-width: 42%;

  --top-p1: calc(37% - var(--gap));
  --top-p2: calc(37% - var(--gap));
  --top-p3: 26%;

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(-50%) translateX(-10px);
    }
    50% {
      opacity: 0;
      transform: translateY(-50%) translateX(-10px);
    }
    100% {
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  }

  @media screen and (max-width: 1200px) {
    --descriptions-width: 50%;
  }

  width: 100%;
  height: 100%;

  pointer-events: none;

  .m-table {
    width: 100%;
    height: 100%;

    .button-box {
      .el-button {
        width: 100%;
      }
    }

    .el-table__body-wrapper {
      @include scrollar-style-thin;
    }
  }

  & > * {
    pointer-events: auto;
  }

  .gps {
    white-space: pre-line;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    cursor: pointer;

    transition: color 0.7s;

    &:hover {
      color: rgb(133, 202, 220);
      filter: brightness(1.5);
    }

    .iconfont {
      font-size: 28px;
    }

    &-text {
      text-align: left;
    }
  }

  .firefighting-button {
    color: #fff !important;
    background-color: #405be6 !important;
    border-color: #405be6 !important;

    &.is-disabled {
      background-color: #8d8d8d !important;
      border-color: #8d8d8d !important;
    }
  }

  .sensors-info {
    display: flex;
    //   justify-content: center;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: var(--monitor-footer-height);
    background: #112132;

    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 6;
    /* padding: 0 250px; */
    box-sizing: border-box;
    padding-right: 200px;

    transition: clip-path 0.8s ease;
    clip-path: inset(0 0 0 0);

    .btn {
      pointer-events: all;
      width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 50%;
      text-align: center;
      cursor: pointer;
      background-color: rgba(27, 171, 253, 0.5);
      color: $primary-text-color;
      font-size: 12px;

      &.right {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);

        animation: fadeIn 1s ease-in-out;
      }
    }

    &_item {
      width: 450px;
      display: flex;
      flex-wrap: wrap;
      line-height: 2.2;

      & > div {
        width: 33%;
      }
    }

    &_chart {
      width: var(--monitor-footer-chart-size);
      height: var(--monitor-footer-chart-size);

      .echarts {
        width: 100%;
        height: 100%;
      }
    }
  }

  .sensors-info.hidden {
    clip-path: inset(0 calc(100% - 48px) 0 0);
  }

  .firefighting-monitor-footer {
    width: 100%;
    height: 180px;

    position: absolute;
    // bottom: 15px;
    bottom: 0;
    left: 50%;
    z-index: 99;
    transform: translate(-50%, 0);

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 15px;
  }

  .el-descriptions {
    width: var(--descriptions-width);

    &__body {
      background: none;

      .el-descriptions-item__cell {
        padding: 10px 0;
      }
    }
  }
}
</style>
